export default "<div class=\"tooltip-box\">\r\n</div>\r\n";